import fixedOdds from '@/library/fixedOdds'

const actions = {
  initBetSlipUpdate (context, d) {
    // console.log('initBetSlipUpdate')
    if (!context.getters.doBetSlipUpdade) {
      context.commit('setBetSlipUpdadeStatus', true)
    }
    context.dispatch('scheduleBetSlipUpdate', d)
  },
  stopBetSlipUpdate (context) {
    // console.log('stopBetSlipUpdate')
    context.commit('setBetSlipUpdadeStatus', false)
  },

  scheduleBetSlipUpdate (context, d) {
    var isLive = false
    // isLive = context.state.isLive
    // isLive = context.getters.isBetSlipLive
    var liveBettingDataSourceType = context.rootGetters['livebettingState/liveBettingDataSourceType']
    // console.log('liveBettingDataSourceType: ' + liveBettingDataSourceType)
    isLive = !!context.getters.liveSelections.length
    if (!d) {
      d = isLive && liveBettingDataSourceType === 'PULL' ? context.state.updateBetSlipInt.live : context.state.updateBetSlipInt.default
    }
    /*
    if (isLive && context.state.triggerUpdate) {
      d++
    }
    */
    context.state.triggerUpdate = false
    if (!context.state.updateBetSlipScheduledIn || d <= context.state.updateBetSlipScheduledIn) {
      // console.log('scheduleBetSlipUpdate in ' + d)
      clearTimeout(context.state.timeouts.updateBetSlipInt)
      context.state.timeouts.updateBetSlipInt = setTimeout(function () {
        context.dispatch('updateBetSlip')
      }, d * 1000)
      context.state.updateBetSlipScheduledIn = d
    }
  },

  checkForBetSlipUpdate (context, betslipMarketsArr) {
    // console.log('checkForBetSlipUpdate:')
    // console.log(betslipMarketsArr)
    if (context.state.currentBetSlipState >= 1 || !context.getters.doBetSlipUpdade) {
      context.dispatch('scheduleBetSlipUpdate')
    } else {
      var delta = false
      betslipMarketsArr.forEach(function (mk) {
        if (mk.selections.length) {
          mk.selections.forEach(function (s) {
            var id = s.idfoselection
            var selection = context.getters.getStoredSelectionById(id)
            if (selection) {
              var hcp = selection.currenthandicap || selection.currentmatchhandicap
              var h = s.currenthandicap || s.currentmatchhandicap
              if (selection.currentpriceup !== s.currentpriceup) {
                delta = 'currentpriceup'
              } else if (selection.currentpricedown !== s.currentpricedown) {
                delta = 'currentpricedown'
              } else if (hcp !== h) {
                delta = 'hcp'
              } else {
                var market = context.getters.getStoredMarketById(id)
                if (market.istradable !== mk.istradable || selection.istradable !== mk.istradable) {
                  delta = 'istradable'
                }
              }
            }
          })
        }
      })
    }
    if (delta) {
      // console.log('delta: ' + delta)
      context.dispatch('scheduleBetSlipUpdate', 0.5)
    }
  },

  updateBetSlip (context, doGetABTnR) {
    // console.log('Vuex updateBetSlip')
    clearTimeout(context.state.timeouts.updateBetSlipInt)
    context.state.updateBetSlipScheduledIn = 0
    var betsNo = context.getters.selectionsNo
    if (!betsNo) {
      context.dispatch('resetBetSlipChanges')
      // clearTimeout(context.state.timeouts.updateBetSlipInt)
    } else {
      if (context.state.currentBetSlipState >= 1 || !context.getters.doBetSlipUpdade) {
        context.dispatch('scheduleBetSlipUpdate')
      } else {
        // console.log(new Date())
        return context.dispatch('updateBetSlipSelections', doGetABTnR).then(
          function (response) {
            context.dispatch('updateStoredBetSlipSelections', response).then(
              function (r) {
                // console.log('should update ABTnR: ' + r + '; doGetABTnR: ' + doGetABTnR)
                /*
                 if (r || doGetABTnR) {
                 // context.dispatch('getAllowedBetTypesAndReturns')
                 context.dispatch('scheduleGetABTnR')
                 }
                 */
              }
            )
            context.dispatch('scheduleBetSlipUpdate')
          })
          .catch(function () {
            console.log('BetSlip update response FAILED!')
            context.dispatch('scheduleBetSlipUpdate')
          })
      }
    }
  },
  updateBetSlipSelections: function (context, updateAll) {
    // updateAll = true
    var liveBettingDataSourceType = context.rootGetters['livebettingState/liveBettingDataSourceType']
    updateAll = updateAll || liveBettingDataSourceType !== 'PUSH'
    // console.log('Vuex updateBetSlipSelections')
    // const selectionsArr = fixedOdds.getSelectionsMappedToBetLegsForBSupdate(context.state.betslipSelections)
    context.state.requestId.updateBetSlipSelections++
    var rqId = context.state.requestId.updateBetSlipSelections

    var selections = context.state.betslipSelections
    if (!updateAll && context.state.liveSelections) {
      selections = selections.filter(s => context.state.liveSelections.indexOf(s.idfoselection) === -1)
    }
    var markets = context.state.markets

    return !selections.length ? [] : fixedOdds.updateBetSlipSelections(selections, markets)
    // return lib.rpcService.callBroker('FixedOddsBettingService', 'UpdateBetSlipSelections', {selections: selectionsArr})
      .then(function (response) {
        if (rqId !== context.state.requestId.updateBetSlipSelections) {
          // console.log('Missmatched request updateBetSlipSelections' + ' rqId: ' + rqId + ' <> ' + context.state.requestId.updateBetSlipSelections)
          return
        }
        // console.log('updateBetSlipSelections on SUCCESS')
        return response
        // return fixedOdds.normalizeUpdatedSelections(response.result)
      })
      .catch(function () {
        // console.log('updateBetSlipSelections ERROR!')
        return {}
      })
  },

  updateSingleBetSlip (context, selection) {
    // console.log('updateSingleBetSlip')
    var isSingleBetSlip = true
    return fixedOdds.updateBetSlipSelections(selection)
      .then(function (response) {
        return fixedOdds.normalizeUpdatedSelections(response.result, isSingleBetSlip)
      })
      .catch(function () {
        return {}
      })
  },

  updateStoredBetSlipSelections: function (context, resultObj) {
    // console.log('$store updateBetSlipSelections')
    var compareSelections = function () {
      var isSingleBetSlip = resultObj && resultObj.isSingleBetSlip
      if (resultObj) {
        delete resultObj.isSingleBetSlip
      }

      var changes = 0
      var id
      var updatedSelection
      var selection
      var i
      var index
      /*
       var priceN = function (price) {
       if (price) {
       if (typeof price === 'string') {
       price = parseFloat(price)
       }
       price = parseFloat(price.toFixed(2))
       }
       return price
       }
       */
      var toUpdate = {
        price: 1,
        currentpriceup: 0,
        currentpricedown: 0,
        currenthandicap: 1,
        // upperband: 0,
        // lowerband: 0,
        isclosed: 1,
        istradable: 1,
        selectionhashcode: 1,
        idfobolifestate: 1,
        csvpricetypes: 1
      }
      for (id in resultObj) {
        updatedSelection = resultObj[id]
        if (isSingleBetSlip) {
          selection = context.state.singleBetSlip.selection
        } else {
          index = context.state.betslipSelections.findIndex(function (s) {
            return s.idfoselection === updatedSelection.idfoselection
          })
          selection = context.getters.betslipSelections[index]
        }
        //
        if (selection) {
          /*
           if (priceN(updatedSelection.price) > priceN(selection.price)) {
           console.log('updatedSelection.price > selection.price')
           selection.priceUp = true
           selection.priceDown = false
           changes++
           } else if (priceN(updatedSelection.price) < priceN(selection.price)) {
           console.log('updatedSelection.price < selection.price')
           selection.priceUp = false
           selection.priceDown = true
           changes++
           }
           */
          for (i in toUpdate) {
            context.state.betSlipChanges[i] = context.state.betSlipChanges[i] || []
            // console.log('(' + selection.idfoselection + ') ' + i + ': ' + selection[i] + ' ?=? ' + updatedSelection[i])
            if (selection[i] !== updatedSelection[i]) {
              // console.log('(' + selection.idfoselection + ') ' + i + ': ' + selection[i] + ' ===> ' + updatedSelection[i])
              /*
               if (toUpdate[i]) {
               console.log('(' + selection.idfoselection + ') ' + i + ': ' + selection[i] + ' => ' + updatedSelection[i])
               }
               */
              selection[i] = updatedSelection[i]
              changes++
              //
              /*
               if (i in context.state.betSlipChanges) {
               if (i === 'isclosed' || i === 'istradable') {
               // selection.hliteNew = false
               } else {
               if (!updatedSelection.isclosed && updatedSelection.istradable) {
               // context.state.betSlipChanges[i]++
               if (context.state.betSlipChanges[i].indexOf(selection.idfoselection) === -1) {
               context.state.betSlipChanges[i].push(selection.idfoselection)
               }
               }
               }
               }
               */
            }
          }
          // selection.changeSet += changes ? 1 : 0
          selection.pricetype = fixedOdds.getdefaultPricetype(selection, context.getters.preferredPriceTypes)
        }
      }
      //
      // context.state.betSlipChanges.isclosed = context.getters.getClosed.length
      // context.state.betSlipChanges.istradable = context.getters.getSuspended.length
      // changes = changes ? 1 : 0
      // context.state.changeNo += changes ? 1 : 0
      // context.state.betSlipChanges.changeNo += changes ? 1 : 0
      return changes
    }

    return new Promise(function (resolve, reject) {
      resolve(compareSelections())
    })
  },

  setBetSlipChange (context, obj) {
    // console.log('setBetSlipChange')
    // console.log(obj)
    var showAcceptingChangesInfo = context.getters.showAcceptingChangesInfo
    var propsToNotify = {
      price: showAcceptingChangesInfo,
      currenthandicap: showAcceptingChangesInfo,
      suspended: showAcceptingChangesInfo,
      closed: showAcceptingChangesInfo,
      NR: showAcceptingChangesInfo
    }
    var priceChanged = false
    var cnt = 0
    var key = obj.key
    var id = obj.id
    var remove = obj.remove

    if (propsToNotify[key]) {
      var index = context.state.betSlipChanges[key].indexOf(id)
      if (remove && index > -1) {
        context.state.betSlipChanges[key].splice(index, 1)
        cnt++
      }
      if (!remove && index >= -1) {
        if (key === 'price') {
          priceChanged = true
        }
        if (index === -1) {
          context.state.betSlipChanges[key].push(id)
        }
        if (key === 'currenthandicap') {
          context.commit('handicapChangedInc')
        }
        cnt++
      }
    }

    context.state.betSlipChanges.changeNo += cnt ? 1 : 0
    context.commit('clearMarkings')
    // console.log('setBetSlipChange ?-> scheduleGetABTnR')
    if (cnt || !showAcceptingChangesInfo || !context.rootGetters.isLoggedIn) {
      // console.log('setBetSlipChange -> scheduleGetABTnR')
      if (priceChanged && context.state.tab !== 'TEASER') {
        context.dispatch('scheduleGetABTnR')
      }
    }
    if (!showAcceptingChangesInfo || !context.rootGetters.isLoggedIn) {
      clearTimeout(context.state.timeouts.killHlite)
      context.state.timeouts.killHlite = setTimeout(function () {
        context.commit('killHlite')
        // context.dispatch('resetBetSlipChanges')
      }, 3 * 1000)
    }
  },

  resetBetSlipChanges (context) {
    // console.log('resetBetSlipChanges')
    // context.dispatch('removeClosedOrSuspended')
    for (var i in context.state.betSlipChanges) {
      if (Array.isArray(context.state.betSlipChanges[i])) {
        context.state.betSlipChanges[i] = []
      } else {
        context.state.betSlipChanges[i] = 0
      }
    }
    context.commit('killHlite')
    context.dispatch('scheduleGetABTnR')
  },

  removeClosedOrSuspended: function (context) {
    // console.log('removeClosedOrSuspended')
    var toRemove = []
    /*
    // toRemove = toRemove.concat(context.state.betSlipChanges.suspended)
    toRemove = toRemove.concat(context.state.betSlipChanges.closed)
    if (context.state.betSlipChanges.suspended.length) {
      context.state.betSlipChanges.suspended.forEach(function (e) {
        if (toRemove.indexOf(e) < 0) {
          toRemove.push(e)
        }
      })
    }
    */
    toRemove = context.state.betslipSelections.filter(function (s) {
      return s.isclosed || !s.istradable
    })

    if (toRemove.length) {
      toRemove.forEach(function (selection) {
        context.dispatch('unsubscribeFromMarket', selection)
        context.commit('removeSelection', selection)
      })
    }
    // context.dispatch('updateBetSlip', true)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/actions/betSlipUpdate.js